import script from "./bulletChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./bulletChat.vue?vue&type=script&setup=true&lang=ts"

import "./bulletChat.vue?vue&type=style&index=0&id=0a1e4d50&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1e4d50"]])

export default __exports__